"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'home_coupon',
  cname: '优惠券',
  icon: 't-icon-zujian-youhuiquan',
  configName: 'c_home_coupon',
  type: 1,
  // 0 基础组件 1 营销组件 2工具组件
  defaultName: 'homeCoupons',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, (0, _vuex.mapState)('mobildConfig', ['defaultArray'])), (0, _vuex.mapGetters)(['mediaDomain', 'mobileTheme'])), {}, {
    //最外层盒子的样式
    boxStyle: function boxStyle() {
      return [{
        'border-radius': this.configObj.bgStyle.val ? this.configObj.bgStyle.val + 'px' : '0'
      }, {
        background: this.listStyle != 3 ? "linear-gradient(to right,".concat(this.configObj.bgColor.color[0].item, ", ").concat(this.configObj.bgColor.color[1].item, ")") : this.configObj.bgColorNew.color[0].item
      }, {
        margin: this.configObj.mbConfig.val + 'px' + ' ' + this.configObj.lrConfig.val + 'px' + ' ' + 0
      }, {
        padding: this.configObj.upConfig.val + 'px' + ' ' + '10px' + ' ' + this.configObj.downConfig.val + 'px'
      }];
    },
    boxBg: function boxBg() {
      return [{
        background: this.configObj.bgColorNew.color[0].item
      }];
    },
    //内容边距
    contentConfig: function contentConfig() {
      return [{
        'margin-right': this.configObj.contentConfig.val ? this.configObj.contentConfig.val + 'px' : '0'
      }, {
        background: this.listStyle == 1 ? this.themeStyle ? this.configObj.itemBgColor.color[0].item : this.mobileTheme : this.listStyle == 3 ? "linear-gradient(180deg,".concat(this.configObj.btnColor.color[0].item, ", ").concat(this.themeStyle ? this.configObj.btnColor.color[1].item : this.mobileTheme, ")") : ''
      }];
    },
    //优惠金额颜色
    priceColorStyle: function priceColorStyle() {
      return [{
        color: this.themeStyle ? this.configObj.priceColor.color[0].item : this.mobileTheme
      }];
    },
    //领取按钮
    btnColorStyle: function btnColorStyle() {
      return [{
        background: "linear-gradient(90deg,".concat(this.configObj.btnColor.color[0].item, ", ").concat(this.themeStyle ? this.configObj.btnColor.color[1].item : this.mobileTheme, ")")
      }];
    },
    //展示数量
    numShow: function numShow() {
      return Math.floor(this.configObj.numConfig.val);
    }
  }),
  watch: {
    pageData: {
      handler: function handler(nVal, oVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    },
    listStyle: function listStyle(nVal, oVal) {
      if (this.configObj.themeStyleConfig.tabVal == 1) {
        if (nVal == 0 || nVal == 2) {
          this.configObj.btnColor.isShow = 0;
        } else {
          this.configObj.btnColor.isShow = 1;
        }
        if (nVal == 1) {
          this.configObj.itemBgColor.isShow = 1;
        } else {
          this.configObj.itemBgColor.isShow = 0;
        }
      }
      if (nVal == 1 || nVal == 2 || nVal == 3) {
        this.configObj.priceColor.color[0].item = '#E93323';
        this.configObj.priceColor.default[0].item = '#E93323';
      } else {
        this.configObj.priceColor.color[0].item = '#FFFFFF';
        this.configObj.priceColor.default[0].item = '#FFFFFF';
      }
      if (nVal == 3) {
        this.configObj.bgColor.isShow = 0;
        this.configObj.bgColorNew.isShow = 1;
      } else {
        this.configObj.bgColor.isShow = 1;
        this.configObj.bgColorNew.isShow = 0;
      }
    },
    themeStyle: {
      handler: function handler(nVal, oVal) {
        if (this.configObj.themeStyleConfig.tabVal == 0) {
          this.configObj.btnColor.isShow = 0;
          this.configObj.itemBgColor.isShow = 0;
          this.configObj.priceColor.isShow = 0;
        }
        if (this.listStyle == 0 || this.listStyle == 2) {
          this.configObj.btnColor.isShow = 0;
        } else {
          this.configObj.btnColor.isShow = this.configObj.themeStyleConfig.tabVal;
        }
        if (this.listStyle == 1) {
          this.configObj.itemBgColor.isShow = this.configObj.themeStyleConfig.tabVal;
        } else {
          this.configObj.itemBgColor.isShow = 0;
        }
        this.configObj.priceColor.isShow = this.configObj.themeStyleConfig.tabVal;
      },
      deep: true
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        isHide: false,
        name: 'homeCoupons',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '优惠券'
        },
        tabConfig: {
          title: '展示样式',
          tabTitle: '布局设置',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '样式1',
            icon: 'iconyouhuiquanyangshiyi'
          }, {
            val: '样式2',
            icon: 'iconyouhuiquanyangshier'
          }, {
            val: '样式3',
            icon: 'iconyouhuiquanyangshisan'
          }, {
            val: '样式4',
            icon: 'iconyouhuiquanyangshisi'
          }]
        },
        logoConfig: {
          isShow: 1,
          tabTitle: '图标设置',
          title: '上传图标',
          tips: '建议：124px*32px',
          url: localStorage.getItem('mediaDomain') + '/crmebimage/perset/202412/yhq.png'
        },
        linkConfig: {
          title: '更多链接',
          val: '/pages/activity/couponList/index',
          place: '请选择链接',
          isShow: 1,
          max: 100
        },
        //数量
        numConfig: {
          tabTitle: '展示内容',
          title: '展示数量',
          strictly: 1,
          val: 5,
          isShow: 1
        },
        // 背景颜色
        bgColor: {
          tabTitle: '颜色设置',
          title: '背景颜色',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }]
        },
        //色调
        themeStyleConfig: {
          title: '色调',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '跟随主题风格'
          }, {
            val: '自定义'
          }]
        },
        // 背景颜色
        bgColorNew: {
          tabTitle: '颜色设置',
          title: '背景颜色',
          isShow: 0,
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        priceColor: {
          isShow: 0,
          title: '优惠金额颜色',
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        btnColor: {
          isShow: 0,
          title: '领取按钮颜色',
          color: [{
            item: '#FF7931'
          }, {
            item: '#E93323'
          }],
          default: [{
            item: '#FF7931'
          }, {
            item: '#E93323'
          }]
        },
        //优惠券背景
        itemBgColor: {
          isShow: 0,
          title: '优惠券背景',
          color: [{
            item: '#E93323'
          }],
          default: [{
            item: '#E93323'
          }]
        },
        bgStyle: {
          tabTitle: '圆角设置',
          title: '背景圆角',
          name: 'bgStyle',
          val: 0,
          min: 0,
          max: 30
        },
        // 上间距
        upConfig: {
          tabTitle: '边距设置',
          title: '上边距',
          val: 10,
          min: 0,
          max: 100
        },
        // 下间距
        downConfig: {
          title: '下边距',
          val: 10,
          min: 0
        },
        // 左右间距
        lrConfig: {
          title: '左右边距',
          val: 12,
          min: 0,
          max: 25
        },
        contentConfig: {
          title: '内容间距',
          val: 5,
          min: 0,
          max: 30
        },
        mbConfig: {
          title: '页面间距',
          val: 10,
          min: 0
        }
      },
      configObj: null,
      listStyle: 0,
      themeStyle: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
      _this.setConfig(pageData);
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      if (data) {
        this.configObj = data;
        this.listStyle = this.configObj.tabConfig.tabVal;
        this.themeStyle = data.themeStyleConfig.tabVal;
      }
    }
  }
};